var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.923096 23.0771H10.8092",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7478 6.41602H14.8616",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7478 12.1484H12.0832",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7478 17.8799H10.2186",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12012 23.0777V3.12075C3.12012 2.53921 3.35089 1.97614 3.76627 1.56998C4.18166 1.16383 4.7355 0.923828 5.31704 0.923828H16.3017C16.8832 0.923828 17.4463 1.1546 17.8524 1.56998C18.2586 1.98537 18.4986 2.53921 18.4986 3.12075V8.79767",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8953 14.6308C15.8953 16.08 17.0768 17.2615 18.526 17.2615C19.9753 17.2615 21.1568 16.08 21.1568 14.6308C21.1568 13.1815 19.9753 12 18.526 12C17.0768 12 15.8953 13.1815 15.8953 14.6308Z",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5262 23.0776C19.7262 23.0776 20.8708 22.9945 21.8954 22.856C22.7354 22.736 23.1047 21.7484 22.5416 21.1114C21.5631 19.9945 20.1231 19.293 18.517 19.293C16.9108 19.293 15.48 19.9945 14.4924 21.1114C13.9293 21.7484 14.2985 22.736 15.1385 22.856C16.1724 23.0037 17.3077 23.0776 18.5077 23.0776H18.5262Z",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingUser);
export default __webpack_public_path__ + "static/media/building-user.f88fe00ac3704b97b9e97565b61e6cb7.svg";
export { ForwardRef as ReactComponent };